import type { FilterRuleModel } from '@/shared/generated'

import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useLocationQuery } from '@/shared/hooks/useLocationQuery'

import { ApprovalTableStatusFilter } from './ApprovalTableStatusFilter'

export default function ApprovalTableViewToggle() {
	const { t } = useTranslation()
	const [{ filters }, setQuery] = useLocationQuery()

	const value = useMemo(() => {
		const statusFilter = filters?.find(
			(filter: FilterRuleModel) => filter.name === 'status'
		)
		if (statusFilter && 'value' in statusFilter) {
			return statusFilter.value as string[]
		} else {
			return undefined
		}
	}, [filters])
	const handleChange = useCallback(
		(value: string[] | undefined) => {
			if (value && value.length > 0) {
				if (
					filters?.find((filter: FilterRuleModel) => filter.name === 'status')
				) {
					setQuery({
						filters: filters.map((filter: FilterRuleModel): FilterRuleModel =>
							filter.name === 'status'
								? { ...filter, operation: 'in', value }
								: filter
						),
					})
				} else {
					setQuery({
						filters: [...filters, { name: 'status', operation: 'in', value }],
					})
				}
			} else {
				const newFilters = filters.filter(
					(filter: FilterRuleModel) => filter.name !== 'status'
				)
				setQuery({
					filters: newFilters.length ? newFilters : null,
				})
			}
		},
		[filters, setQuery]
	)

	return (
		<ApprovalTableStatusFilter
			onChange={handleChange}
			value={value}
			title={t('app.status')}
		/>
	)
}
